import { render, staticRenderFns } from "./purchase-bak.vue?vue&type=template&id=7f80a99d&scoped=true&"
import script from "./purchase-bak.vue?vue&type=script&lang=js&"
export * from "./purchase-bak.vue?vue&type=script&lang=js&"
import style0 from "./purchase-bak.vue?vue&type=style&index=0&id=7f80a99d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80a99d",
  null
  
)

export default component.exports